import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';

const GalleryBox = ({ photos }) => {
  const [index, setIndex] = useState(-1);

  const slides = photos.map((photo) => ({
    src: `https://filmconnx-production.s3.amazonaws.com/uploads/${photo.file}`,
  }));

  return (
    <div className="mb-7 mt-7">
      <h3 className="text-3xl font-semibold mb-5">Portfolio</h3>
      <div className="flex flex-wrap -mx-2">
        {photos.map((photo, idx) => (
          <div
            key={photo.photoid}
            className="w-1/2 sm:w-1/3 md:w-1/4 p-2"
            onClick={() => setIndex(idx)}
          >
            <div className="relative w-full pt-[100%] cursor-pointer">
              <img
                src={`https://filmconnx-production.s3.amazonaws.com/uploads/${photo.file}`}
                alt="resource"
                className="absolute top-0 left-0 w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        ))}
      </div>

      {index >= 0 && (
        <Lightbox
          open={index >= 0}
          close={() => setIndex(-1)}
          slides={slides}
          index={index}
          carousel={{ finite: photos.length <= 1 }}
          zoom={{
            maxZoomPixelRatio: 10,
          }}
          plugins={[Fullscreen, Zoom]}
          controller={{ closeOnBackdropClick: true }}
        />
      )}
    </div>
  );
};

export default GalleryBox;
